import { render, staticRenderFns } from "./ImportRegistrationsModal.vue?vue&type=template&id=065bba5e"
import script from "./ImportRegistrationsModal.vue?vue&type=script&lang=js"
export * from "./ImportRegistrationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports